import { Routes } from "@/app/routes.ts";
import { ErrorHeader } from "@/components/layouts/ErrorHeader.tsx";
import { NotFoundIllustration } from "@/components/ui/illustrations/not-found/NotFoundIllustration.tsx";
import { Div, Flex, H1, LinkButton } from "@hopper-ui/components";
import { useTranslation } from "react-i18next";

export const NotFoundErrorPage = () => {
    const { t } = useTranslation();

    return (
        <Div
            backgroundColor="core_toad-50"
            position="relative"
        >
            <ErrorHeader />
            <Flex
                justifyContent="center"
                alignItems="center"
                UNSAFE_minHeight="100dvh"
                backgroundColor="core_toad-50"
            >
                <Div
                    textAlign="center"
                    paddingX="inset-md"
                >
                    <NotFoundIllustration />
                    <H1
                        margin="core_0"
                        fontSize={{
                            base: "heading-lg",
                            sm: "heading-2xl"
                        }}
                        color="core_rock-800"
                    >
                        {t("errorPages.notFound.title")}
                    </H1>
                    <Div
                        marginTop="inline-xs"
                        fontSize={{
                            base: "body-sm",
                            sm: "body-md"
                        }}
                        color="core_rock-800"
                    >
                        {t("errorPages.notFound.description")}
                    </Div>
                    <LinkButton
                        marginX="auto"
                        marginTop="inline-lg"
                        href={Routes.Home()}
                    >
                        {t("errorPages.notFound.ctaLabel")}
                    </LinkButton>
                </Div>
            </Flex>
        </Div>
    );
};
